<template>
  <div>
    <!-- <LandSolutionBanner /> -->
    <LandBanner :bannerUrl="bannerUrl" :bannerTitle="bannerTitle" :bannerText="bannerText"></LandBanner>
    <div class="solution-video">
      <div class="solution-video-title">建设方数字新成本解决方案</div>
      <div class="solution-video-text">
        解决方案以项目数据、企业数据、行业数据为主体架构，实现数据资产的自动沉淀、业务上的全过程数据打通、管理上数据实时分析统计，解决企业成本标准落地难、成本编制效率低、成本数据统计难等业务问题，助力建设方达成成本精细化管理的目标。
      </div>
      <video-play
        v-if="showVideo"
        :src="videoList.fileUrl"
        @close="showVideo = false"
      ></video-play>
      <div
        class="solution-video-url"
        v-if="videoList.fileType==='video'"
        @mouseover="isMask=true"
        @mouseleave="isMask=false"
      >
        <div id="poster">
          <div
            class="video-img"
            style="position: relative;width: 868px;height: 444px;"
          >
            <img
              :src="videoImg"
              style="border-radius: 17px;height: 100%;width: 100%;"
            />
          </div>
          <div
            class="video-img-mask"
            v-show="isMask"
            style="position: relative;width: 868px;height: 444px;margin-top:-444px;
            background: #1F1F1F;
            border-radius: 17px;
            opacity: 0.72;"
          >
          </div>
          <div
            class="video-play"
            @click="onPlay(videoList.clientGroup)"
          >
            <img :src="playImg" />
          </div>
        </div>
      </div>
      <div
        class="solution-video-url"
        v-else-if="videoList.fileType==='image'"
      >
        <img
          :src="videoList.fileUrl"
          style="border-radius: 17px;width:868px;height: 444px;"
        />
      </div>
    </div>
    <div class="solution-architecture">
      <div class="solution-architecture-title">建设方-方案架构</div>
      <div class="solution-architecture-img">
        <img :src="architectureUrl" />
      </div>
    </div>
    <div class="solution-value">
      <div class="solution-value-title">方案核心价值</div>
      <div class="solution-value-img">
        <div class="value-img">
          <div class="value-img-title">01</div>
          <div class="value-img-text">
            <div class="img-title">
              搭建科学合理的<br />
              成本指标体系
            </div>
            <div class="img-text">
              快速建立企业成本数据标准体系，规范成本管控作业格式；<br /><br />
              完成工作即完成标准数据积累，数据积累无负担；<br /><br />
              作业过程即调用企业数据标准，成本管理高效高质；<br /><br />
              科学合理的成本科目划分，结构性、功能性、敏感性。
            </div>
          </div>
        </div>
        <div class="value-img">
          <div
            class="value-img-title"
            style="background: #ECECFF;color: #6363FF;"
          >
            02
          </div>
          <div
            class="value-img-text"
            style="background: linear-gradient(180deg, #8888FF 0%, #6363FF 100%);"
          >
            <div class="img-title">数据驱动<br />成本高效作业</div>
            <div
              class="img-text"
              style="line-height: 22px;"
            >
              灵活调取库内成本指标数据，三步完成目标成本测算；<br /><br />
              一键方案对比，快速完成方案比选；<br /><br />
              成本科目高效、精准拆分至合约规划，实现成本合约数据实时联动；<br /><br />
              一键调用清单作业模板，快速完成清单编制；<br /><br />
              一键投标报价分析，清标效率提升10倍。
            </div>
          </div>
        </div>
        <div class="value-img">
          <div
            class="value-img-title"
            style="background:#DFF8FF;color:#2AC0E7;"
          >
            03
          </div>
          <div
            class="value-img-text"
            style="background: linear-gradient(180deg, #00D1E9 0%, #00AAD6 100%)"
          >
            <div class="img-title">参考优秀做法<br />项目成本策划更优</div>
            <div class="img-text">
              内置关键科目的成本控制要素；<br /><br />
              项目关键科目指标自检，排除设计方案风险；<br /><br />
              内外部参考对标，全国政策文件同步更新，补齐企业短板。
            </div>
          </div>
        </div>
        <div class="value-img">
          <div
            class="value-img-title"
            style="background: #FFF5E7;color: #FFB046;"
          >
            04
          </div>
          <div
            class="value-img-text"
            style="background: linear-gradient(180deg, #FBC83B 0%, #F5981B 100%);"
          >
            <div class="img-title">
              数据赋能业务<br />
              建设企业成本管控依据
            </div>
            <div class="img-text">
              一键完成项目后评估，快速识别优化成本项；<br /><br />
              大数据动态分析历史数据，获取最新成本数据；<br /><br />
              基于平台数据分析能力，建设及优化企业基准成本、产品适配标准及限额指标标准。<br /><br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solution-case">
      <LandSolutionCase />
    </div>
    <LandHomePurchase />
  </div>
</template>

<script>
import LandHomePurchase from '../land-home/components/LandHomePurchase.vue'
// import LandSolutionBanner from './components/LandSolutionBanner.vue'
import LandBanner from '../../../../../components/LandBanner.vue'
import LandSolutionCase from './components/LandSolutionCase.vue'
import VideoPlay from './components/VideoPlay/Index.vue'
import { getVideoList } from '@/api/landing'
const videoImg1 = require('../../../../../assets/images/land-page/land-home/videoMask1.jpg')
const playImg = require('@/assets/images/svg/play.svg')
const architectureUrl = require('@/assets/images/land-page/land-home/developer1.png')
const bannerUrl = require('../../../../../assets/images/land-page/land-home/construction-banner2.jpg')
export default {
  name: 'landSolution2',
  mounted () {
    this.getList()
  },
  components: {
    // LandSolutionBanner,
    LandBanner,
    LandSolutionCase,
    LandHomePurchase,
    VideoPlay
  },
  data () {
    return {
      architectureUrl: architectureUrl,
      videoImg: videoImg1,
      videoList: [],
      showVideo: false,
      playImg,
      isMask: false,
      bannerUrl,
      bannerTitle: '建设方 数字新成本解决方案',
      bannerText: '以企业成本数据积累与应用的闭环打通为核心，依托科学的成本指标体系高效沉淀数据资产，实现以成本指标度量选择更优的设计方案、设立更合理的成本目标、控制工程招标采购价不超目标、过程及时预警管控超支风险；助力企业成本管理更精准，PDCA速度更快，从而达成精细化成本管控的目标，实现项目成本更合理，项目价值最优。'
    }
  },
  methods: {
    onPlay (typeName) {
      this.sentLog(100102005, { type: typeName })
      this.showVideo = true
    },
    // 获取列表
    getList () {
      getVideoList()
        .then(res => {
          const { code, data, message } = res
          if (code === 200) {
            for (let index = 0; index < data.length; index++) {
              if (data[index].clientGroup === '建设方') {
                this.videoList = data[index] || []
              }
            }
          } else {
            this.videoList = []
            message && this.$message.error(message)
          }
        })
        .catch(() => {
          this.videoList = []
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-video {
  height: 772px;
  width: 1200px;
  margin: auto;
  .solution-video-title {
    padding-top: 67px;
    font-size: 40px;
    font-weight: 600;
    color: #181f42;
    line-height: 56px;
    text-align: center;
    margin: 0 auto 18px auto;
  }
  .solution-video-text {
    width: 868px;
    font-size: 16px;
    font-weight: 400;
    color: #5c5c65;
    line-height: 28px;
    text-align: center;
    margin: auto;
  }
  .video-dialog {
    width: 100%;
  }
  .solution-video-url {
    width: 868px;
    height: 444px;
    border-radius: 17px;
    margin: 40px auto 0 auto;
    .video-play {
      width: 78px;
      height: 78px;
      background: #fff;
      position: relative;
      margin-top: -289px;
      margin-left: 396px;
      z-index: 2;
      border-radius: 50%;
    }
    .video-play:hover {
      cursor: pointer;
    }
  }
}
.solution-architecture {
  height: 1036px;
  width: 100%;
  margin: auto;
  background: url("../../../../../assets/images/land-page/land-home/construction-bg.png")
    no-repeat;
  background-size: cover;
  .solution-architecture-title {
    padding-top: 45px;
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    line-height: 56px;
    text-align: center;
    margin: 0 auto 29px auto;
  }
  .solution-architecture-img {
    width: 1085px;
    height: 813px;
    background-color: #ffffff30;
    border-radius: 10px;
    margin: auto;
    padding: auto;
    display: flex;
    img {
      width: 1037px;
      height: 762px;
      margin: auto;
      display: block;
      opacity: 1 !important;
      object-fit: contain;
    }
  }
}
.solution-value {
  height: 796px;
  margin: auto;
  .solution-value-title {
    padding-top: 74px;
    padding-bottom: 42px;
    font-size: 40px;
    font-weight: 600;
    color: #181f42;
    line-height: 56px;
    text-align: center;
    margin: 0 auto;
  }
  .solution-value-img {
    width: 1200px;
    height: 552px;
    margin: auto;
    display: flex;
    .value-img {
      margin-right: 26px;
      .value-img-title {
        width: 96px;
        height: 96px;
        background: #e8f2ff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
        z-index: 1;
        margin-bottom: -48px;
        margin-left: 93px;
        border-radius: 50%;
        position: relative;
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        color: #1d7fff;
        line-height: 96px;
      }
      .value-img-text {
        width: 281px;
        height: 506px;
        background: linear-gradient(180deg, #3eb5ff 0%, #1d7fff 100%);
        border-radius: 10px;
        .img-title {
          width: 224px;
          font-size: 22px;
          font-weight: 500;
          color: #fff;
          line-height: 30px;
          padding-top: 69px;
          text-align: center;
          margin: auto;
        }
        .img-text {
          width: 234px;
          font-size: 18px;
          font-weight: 400;
          color: #fff;
          line-height: 26px;
          text-align: left;
          margin: 21px auto 0 auto;
        }
      }
    }
  }
}
.solution-case {
  height: 740px;
  margin: auto;
}
</style>
